import React from "react";
import { useSelector } from "react-redux";
import AnalyticsDashboard from "../../components/analytics/AnalyticsDashboard";

export default function TeacherAnalyticsPage() {
    const { currentUser } = useSelector((state) => state.user);
    const schoolId = currentUser?.school?._id || currentUser?.schoolId;
    const teacherId = currentUser?._id;

    return <AnalyticsDashboard mode="teacher" schoolId={schoolId} teacherId={teacherId} />;
}
